<template>
  <div class="newSlideshow">
    <el-form ref="form" :model="form" :rules="rules" label-width="200px">
      <el-form-item label="隐私政策名称" prop="name">
        <el-input
          style="width: 600px"
          v-model="form.name"
          placeholder="请输入隐私政策名称"
          maxlength="50"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="隐私政策内容" prop="link">
        <WangEditorVue @getEditorContent="getEditorContent"></WangEditorVue>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit('form')">完成</el-button>
        <el-button @click="onCancel">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import WangEditorVue from "@/components/WangEditor.vue";
import { saveAgreement } from "@/api/agreementManagement";
export default {
  components: { WangEditorVue },
  data() {
    return {
      form: {
        name: "",
        link: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入隐私政策名称",
            trigger: "blur",
          },
        ],
        link: [
          {
            required: true,
            message: "请输入隐私政策内容",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    onSubmit(formName) {
      if (!this.stripHtmlTags(this.form.link)) {
        this.$message({
          message: "请输入隐私政策内容",
          type: "warning",
        });
        return false;
      }
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let res = saveAgreement({
            name: this.form.name,
            content: this.form.link,
            type: 1,
          });
          res.then((data) => {
            if (data.data.result == "success") {
              this.$message({
                message: "保存成功",
                type: "success",
              });
              this.$router.back();
            }
            console.log(res, valid);
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getEditorContent(val) {
      console.log(this.stripHtmlTags(val), "val", val);
      this.form.link = val;
    },
    // 过滤字符串中的标签，保留内容部分
    stripHtmlTags(str) {
      if (str === null || str === "") return false;
      else str = str.toString();
      return str.replace(/<[^>]*>/g, "");
    },
    onCancel() {
      console.log("cancel!");
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
.newSlideshow {
  width: 80%;
}
</style>
